import styled from 'styled-components'

import * as Toast from '@radix-ui/react-toast'
import { Button } from '@radix-ui/themes'

export const StyledToast = styled(Toast.Root)``

export const StyledToastViewport = styled(Toast.Viewport)`
    --viewport-padding: 25px;
    position: fixed;
    bottom: 0;
    right: 0;
    display: flex;
    flex-direction: column;
    padding: var(--viewport-padding);
    gap: 10px;
    width: 390px;
    max-width: 100vw;
    margin: 0;
    list-style: none;
    z-index: 2147483647;
    outline: none;
`

export const StyledToastCloseButton = styled(Button)``

export const ToastCard = styled.div<{
    $type: 'warning' | 'success' | 'error' | 'info'
}>`
    ${props => {
        switch (props.$type) {
            case 'success': {
                return `
                    --toast-background: var(--green-5);
                    --toast-border: var(--green-6);
                `
            }

            case 'warning': {
                return `
                    --toast-background: var(--yellow-5);
                    --toast-border: var(--yellow-6);
                `
            }

            case 'error': {
                return `
                    --toast-background: var(--red-5);
                    --toast-border: var(--red-6);
                `
            }

            case 'info':
            default: {
                return `
                    --toast-background: var(--gray-5);
                    --toast-border: var(--gray-6);
                `
            }
        }
    }}

    background-color: var(--toast-background);
    border: 1px solid var(--toast-border);
    border-radius: var(--radius-4);
    box-shadow: var(--shadow-4);
`

export const ToastMessage = styled(ToastCard)`
    div > div > div:first-child {
        font-weight: 900;
        font-size: 1.1rem;
    }

    position: relative;
    padding: 1rem;
    display: flex;
    flex-direction: column;
    gap: 1rem;
    justify-content: space-between;
`
